export enum LoaderStyle {
  height = '35px',
  width150 = '150px',
  width200 = '200px',
  width250 = '250px',
  width400 = '400px',
  height900 = '900px',
  width100 = '100%',
  height100 = '100%',
  height24 = '24px',
  width130 = '130px',
  width = '100px',
  height20 = '20px',
  width129 = '129px',
  height36 = '36px'
}

export type StyledSkeletonLoaderProps = {
  readonly variant?: string;
  readonly height?: string;
  readonly width?: string;
  readonly style?: React.CSSProperties;
  readonly count?: number;
};

export type StyledDivProps = {
  readonly variant?: string;
  readonly borderHidden?: boolean;
};

export type SkeletonHeaderProps = {
  readonly type: string;
};

export type GridSkeletonType = {
  rows: number;
  columns: number;
};
